/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateStudentRequest
 */
export interface CreateStudentRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    selfEnrollment: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    lastName: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateStudentRequest
     */
    dateOfBirth: Date;
    /**
     * 
     * @type {Gender}
     * @memberof CreateStudentRequest
     */
    gender: Gender;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateStudentRequest
     */
    locationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateStudentRequest
     */
    parentId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    medications?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    allergies?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    specialNeeds?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    primaryDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    preferredName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    cellPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStudentRequest
     */
    address?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    postPublicly?: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof CreateStudentRequest
     */
    startDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateStudentRequest
     */
    dropDate?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    sendSms?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateStudentRequest
     */
    discountPercentage?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    noCharge?: boolean | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateStudentRequest
     */
    tuition?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    isTuitionOverridden?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStudentRequest
     */
    recital?: boolean | null;
}



/**
 * Check if a given object implements the CreateStudentRequest interface.
 */
export function instanceOfCreateStudentRequest(value: object): value is CreateStudentRequest {
    if (!('selfEnrollment' in value) || value['selfEnrollment'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined) return false;
    return true;
}

export function CreateStudentRequestFromJSON(json: any): CreateStudentRequest {
    return CreateStudentRequestFromJSONTyped(json, false);
}

export function CreateStudentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStudentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selfEnrollment': json['selfEnrollment'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'gender': GenderFromJSON(json['gender']),
        'locationIds': ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'parentId': json['parentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['parentId']),
        'medications': json['medications'] == null ? undefined : json['medications'],
        'allergies': json['allergies'] == null ? undefined : json['allergies'],
        'specialNeeds': json['specialNeeds'] == null ? undefined : json['specialNeeds'],
        'primaryDoctor': json['primaryDoctor'] == null ? undefined : json['primaryDoctor'],
        'preferredName': json['preferredName'] == null ? undefined : json['preferredName'],
        'cellPhone': json['cellPhone'] == null ? undefined : json['cellPhone'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'postPublicly': json['postPublicly'] == null ? undefined : json['postPublicly'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'dropDate': json['dropDate'] == null ? undefined : json['dropDate'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'discountPercentage': json['discountPercentage'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['discountPercentage']),
        'noCharge': json['noCharge'] == null ? undefined : json['noCharge'],
        'tuition': json['tuition'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['tuition']),
        'isTuitionOverridden': json['isTuitionOverridden'] == null ? undefined : json['isTuitionOverridden'],
        'recital': json['recital'] == null ? undefined : json['recital'],
    };
}

export function CreateStudentRequestToJSON(json: any): CreateStudentRequest {
    return CreateStudentRequestToJSONTyped(json, false);
}

export function CreateStudentRequestToJSONTyped(value?: CreateStudentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selfEnrollment': value['selfEnrollment'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'dateOfBirth': value['dateOfBirth'].toISOString().substring(0,10),
        'gender': GenderToJSON(value['gender']),
        'locationIds': ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'parentId': ActorActivityRecordActorUserIdToJSON(value['parentId']),
        'medications': value['medications'],
        'allergies': value['allergies'],
        'specialNeeds': value['specialNeeds'],
        'primaryDoctor': value['primaryDoctor'],
        'preferredName': value['preferredName'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'email': value['email'],
        'address': value['address'],
        'postPublicly': value['postPublicly'],
        'startDate': value['startDate'],
        'dropDate': value['dropDate'],
        'sendSms': value['sendSms'],
        'discountPercentage': BalanceUnitStatementEntryDebitToJSON(value['discountPercentage']),
        'noCharge': value['noCharge'],
        'tuition': BalanceUnitStatementEntryDebitToJSON(value['tuition']),
        'isTuitionOverridden': value['isTuitionOverridden'],
        'recital': value['recital'],
    };
}

